import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import clsx from "clsx";
import { Box, Grid, Typography } from "@material-ui/core";
import useStyles from "./style";

function DashboardCard({ title, secondaryTitle, icon, className, children, ...rest }) {
    const classes = useStyles();

    return (
        <Card className={clsx("h-100", "w-100", className)} {...rest}>
            {(title || icon) && (
                <CardHeader
                    classes={{
                        content: classes.headerTitle
                    }}
                    title={
                        secondaryTitle ? (
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="primary">
                                        {title}
                                    </Typography>
                                </Grid>

                                <Grid item xs={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography variant="subtitle1" color="primary">
                                        {secondaryTitle}
                                    </Typography>
                                    {icon && (
                                        <SvgIcon component={icon} color="primary" fontSize="large" className={classes.icon} />
                                    )}
                                </Grid>
                            </Grid>
                        ) : (
                            <Box display="flex" alignItems="center">
                                <Typography variant="subtitle1" color="primary">
                                    {title}
                                </Typography>
                            </Box>
                        )
                    }
                    action={
                        (!secondaryTitle && icon) && (
                            <SvgIcon component={icon} color="primary" fontSize="large" className={classes.icon} />
                        )
                    }
                />
            )}
            <CardContent className="h-100">{children}</CardContent>
        </Card>
    );
}

export default DashboardCard;